import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Marketing short links use `{{origin}}/?c={{short_code}}`. The server resolves `c` on
 * `GET /api/campaign-redirect?c=...` (partner `publicLinkCode` from bundled branding, or a
 * `marketing_attribution.id` UUID). When the SPA loads at `/` with `c`, send the browser there
 * so the API can 302 to the expanded UTM URL.
 */
export const CampaignShortLinkRedirect = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        if (location.pathname !== '/') {
            return;
        }
        const params = new URLSearchParams(location.search);
        const raw = params.get('c');
        const code = raw?.trim();
        if (!code) {
            return;
        }
        const target = `${window.location.origin}/api/campaign-redirect?c=${encodeURIComponent(code)}`;
        window.location.replace(target);
    }, [location.pathname, location.search]);

    return null;
};
